var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeskPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 177,
    viewBox: "0 0 243 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 77307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M243.989 176.494H205.616C204.372 176.494 203.349 175.48 203.349 174.227V93.8265C203.349 92.5828 204.363 91.5591 205.616 91.5591H243.989C245.242 91.5591 246.256 92.5732 246.256 93.8265V174.227C246.256 175.47 245.242 176.494 243.989 176.494ZM205.616 92.0375C204.631 92.0375 203.827 92.8411 203.827 93.8265V174.227C203.827 175.212 204.631 176.016 205.616 176.016H243.989C244.974 176.016 245.778 175.212 245.778 174.227V93.8265C245.778 92.8411 244.974 92.0375 243.989 92.0375H205.616Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M243.989 176.609H205.617C204.306 176.609 203.234 175.538 203.234 174.227V93.8268C203.234 92.5162 204.306 91.4447 205.617 91.4447H243.989C245.3 91.4447 246.371 92.5162 246.371 93.8268V174.227C246.371 175.538 245.31 176.609 243.989 176.609ZM205.617 91.6743C204.43 91.6743 203.474 92.6406 203.474 93.8173V174.217C203.474 175.404 204.44 176.36 205.617 176.36H243.989C245.176 176.36 246.132 175.394 246.132 174.217V93.8173C246.132 92.631 245.166 91.6743 243.989 91.6743H205.617ZM243.989 176.131H205.617C204.564 176.131 203.713 175.279 203.713 174.227V93.8268C203.713 92.7745 204.564 91.923 205.617 91.923H243.989C245.042 91.923 245.893 92.7745 245.893 93.8268V174.227C245.893 175.279 245.042 176.131 243.989 176.131ZM205.617 92.1526C204.698 92.1526 203.952 92.8989 203.952 93.8173V174.217C203.952 175.136 204.698 175.882 205.617 175.882H243.989C244.908 175.882 245.654 175.136 245.654 174.217V93.8173C245.654 92.8989 244.908 92.1526 243.989 92.1526H205.617Z",
    fill: "#DDDDDD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M246.017 108.51H203.598V108.778H246.017V108.51Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M246.131 108.892H203.473V108.385H246.131V108.892ZM203.712 108.653H245.892V108.624H203.712V108.653Z",
    fill: "#DDDDDD"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M246.017 126.28H203.598V126.547H246.017V126.28Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M246.131 126.67H203.473V126.163H246.131V126.67ZM203.712 126.431H245.892V126.402H203.712V126.431Z",
    fill: "#DDDDDD"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M246.017 143.949H203.598V144.217H246.017V143.949Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M246.131 144.341H203.473V143.833H246.131V144.341ZM203.712 144.101H245.892V144.073H203.712V144.101Z",
    fill: "#DDDDDD"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M246.017 160.928H203.598V161.196H246.017V160.928Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M246.131 161.32H203.473V160.813H246.131V161.32ZM203.712 161.081H245.892V161.052H203.712V161.081Z",
    fill: "#DDDDDD"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M227.622 107.314H221.996C221.92 107.314 221.862 107.257 221.862 107.181C221.862 107.104 221.92 107.047 221.996 107.047H227.622C227.698 107.047 227.756 107.104 227.756 107.181C227.756 107.257 227.689 107.314 227.622 107.314Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M227.621 107.43H221.996C221.852 107.43 221.737 107.315 221.737 107.172C221.737 107.028 221.852 106.913 221.996 106.913H227.621C227.764 106.913 227.879 107.028 227.879 107.172C227.87 107.325 227.755 107.43 227.621 107.43ZM221.996 107.162V107.191H227.621C227.631 107.191 227.64 107.181 227.64 107.172L221.996 107.162Z",
    fill: "#DDDDDD"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M227.622 124.642H221.996C221.92 124.642 221.862 124.585 221.862 124.508C221.862 124.432 221.92 124.374 221.996 124.374H227.622C227.698 124.374 227.756 124.432 227.756 124.508C227.756 124.575 227.689 124.642 227.622 124.642Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M227.622 124.757H221.997C221.853 124.757 221.738 124.643 221.738 124.499C221.738 124.356 221.853 124.241 221.997 124.241H227.622C227.765 124.241 227.88 124.356 227.88 124.499C227.871 124.643 227.756 124.757 227.622 124.757ZM221.997 124.489V124.518H227.622C227.632 124.518 227.641 124.509 227.641 124.499L221.997 124.489Z",
    fill: "#DDDDDD"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M227.623 141.516H221.997C221.921 141.516 221.863 141.458 221.863 141.382C221.863 141.305 221.921 141.248 221.997 141.248H227.623C227.699 141.248 227.756 141.305 227.756 141.382C227.756 141.449 227.69 141.516 227.623 141.516Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M227.622 141.631H221.997C221.853 141.631 221.738 141.516 221.738 141.373C221.738 141.229 221.853 141.114 221.997 141.114H227.622C227.765 141.114 227.88 141.229 227.88 141.373C227.871 141.516 227.756 141.631 227.622 141.631ZM221.997 141.363V141.392H227.622C227.632 141.392 227.641 141.382 227.641 141.373L221.997 141.363Z",
    fill: "#DDDDDD"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M227.621 158.95H221.995C221.919 158.95 221.861 158.893 221.861 158.816C221.861 158.74 221.919 158.682 221.995 158.682H227.621C227.697 158.682 227.755 158.74 227.755 158.816C227.755 158.893 227.688 158.95 227.621 158.95Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M227.62 159.074H221.995C221.851 159.074 221.736 158.959 221.736 158.816C221.736 158.672 221.851 158.557 221.995 158.557H227.62C227.763 158.557 227.878 158.672 227.878 158.816C227.869 158.959 227.754 159.074 227.62 159.074ZM221.995 158.806V158.835H227.62C227.63 158.835 227.639 158.825 227.639 158.816L221.995 158.806Z",
    fill: "#DDDDDD"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 77306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M126.868 87.0777H2.86007C1.5245 87.0777 0.456055 86.0092 0.456055 84.6736C0.456055 83.338 1.5245 82.2696 2.86007 82.2696H126.868C128.204 82.2696 129.272 83.338 129.272 84.6736C129.272 86.0092 128.137 87.0777 126.868 87.0777Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M160.325 17.9611C162.061 23.9712 157.854 30.1816 153.246 31.5172C148.639 32.8528 145.366 28.7125 143.697 22.7024C141.961 16.6923 144.298 10.749 148.906 9.41344C153.513 8.14465 158.655 11.951 160.325 17.9611Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 1.05961
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M134.547 134.69C134.547 134.69 146.3 152.987 147.903 153.788C149.506 154.59 153.446 154.79 151.977 157.795C150.507 160.8 149.906 172.486 148.504 173.087C147.102 173.688 135.215 175.091 136.951 173.087C138.754 171.084 139.823 172.086 140.758 168.546C141.693 164.94 142.961 158.196 141.225 156.793C139.556 155.391 129.205 142.903 129.205 142.903L134.547 134.69Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 1.05961
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M75.3149 142.503C75.3149 142.503 61.0243 166.076 58.3531 168.213C55.682 170.35 46.934 173.488 54.0793 174.022C61.2247 174.557 64.6971 171.618 69.1713 170.283C73.6455 168.947 79.2549 168.146 77.118 164.74C74.9811 161.268 75.8492 153.788 80.4569 148.98C85.0646 144.306 75.3149 142.503 75.3149 142.503Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 1.05961
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M148.371 87.8108C148.371 87.8108 112.911 86.8759 98.888 98.4286C90.6742 110.916 70.7742 147.644 69.2383 151.718C70.3067 152.786 76.25 154.723 78.9212 154.456C86.7343 145.107 97.085 137.093 101.158 129.748C106.234 120.733 107.77 116.259 115.983 115.457C124.197 114.656 142.762 111.985 148.304 111.985C153.914 111.918 148.371 87.8108 148.371 87.8108Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M179.222 174.156H177.419L164.063 118.529H168.137L179.222 174.156Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M123.596 174.155H125.465L140.758 116.592H136.684L123.596 174.155Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M172.221 85.2623L147.903 88.9464C147.903 88.9464 120.524 89.2135 108.036 91.5508C96.6169 93.6877 94.9474 106.643 108.036 124.406C115.448 134.556 121.726 142.57 134.547 151.718C137.819 149.314 139.088 148.446 139.956 142.636C139.021 141.368 136.617 133.421 135.883 131.818C128.804 116.993 119.322 111.584 119.188 110.115C120.791 107.511 163.051 123.901 171.131 114.419C178.811 105.403 172.221 85.2623 172.221 85.2623Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M144.53 67.4311L144.53 67.4303C144.202 55.1343 149.179 47.6526 153.64 43.1159C158.569 39.5442 163.864 38.542 169.059 39.1879C169.605 40.4405 170.301 41.6554 170.977 42.8349C171.131 43.1041 171.285 43.3715 171.435 43.6371C176.035 52.9776 175.5 60.7809 174.239 68.4393C174.038 69.6565 173.819 70.8726 173.598 72.0923C172.435 78.5347 171.254 85.0746 172.79 92.3882L172.79 92.389C173.412 95.3239 173.617 97.5118 173.495 99.0928C173.372 100.68 172.928 101.572 172.342 102.037C171.76 102.498 170.916 102.633 169.761 102.418C168.61 102.204 167.233 101.655 165.686 100.864C162.968 99.474 159.83 97.3947 156.613 95.2634C156.167 94.9678 155.719 94.6713 155.271 94.3754C151.667 91.9964 148.022 89.6609 144.896 88.3425C144.228 87.3406 143.902 86.5489 143.763 85.7114C143.616 84.8231 143.672 83.849 143.818 82.4542C143.853 82.1263 143.892 81.7781 143.933 81.4058C144.245 78.6155 144.708 74.4748 144.53 67.4311Z",
    stroke: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M169.406 38.7289C166.067 30.849 165.266 21.9007 165.266 21.9007L156.518 24.5051C156.518 24.5051 161.46 35.6571 156.718 39.597C155.717 40.4652 154.515 41.4668 153.312 42.7356C158.454 38.996 163.997 37.9944 169.406 38.7289Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 1.05961
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M158.588 120.866C158.054 120.866 157.453 120.866 156.852 120.866C149.506 120.665 144.498 119.664 140.491 118.862C135.817 117.927 133.212 117.393 130.207 118.796C129.072 119.33 127.67 118.862 127.136 117.727C126.601 116.592 127.069 115.189 128.204 114.655C132.611 112.518 136.284 113.32 141.426 114.321C145.233 115.123 150.041 116.058 156.986 116.258C164.732 116.458 169.473 115.323 171.877 112.652C174.014 110.315 174.615 106.308 173.814 100.098C173.547 97.9606 173.28 96.2243 173.012 94.6884C172.345 90.281 171.877 87.4096 172.411 82.9354C172.946 78.7951 174.281 73.2525 177.487 62.5011C177.821 61.2991 179.156 60.5645 180.358 60.9652C181.56 61.2991 182.295 62.6347 181.894 63.8367C175.951 83.8035 176.285 85.7401 177.553 93.9539C177.821 95.5566 178.088 97.2928 178.355 99.4965C179.356 107.109 178.355 112.251 175.216 115.724C172.144 119.263 166.936 120.866 158.588 120.866Z",
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M76.2501 162.404C66.7675 167.078 61.6256 169.683 58.6205 169.482C57.886 169.415 57.2849 169.349 56.8175 169.282C53.4118 171.285 48.0027 173.622 54.0796 174.09C61.2249 174.624 64.6974 171.686 69.1715 170.35C73.6457 169.015 79.2551 168.213 77.1182 164.808C76.7175 164.14 76.4504 163.339 76.2501 162.404Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M148.972 154.122C148.771 161.668 147.703 169.081 143.095 170.483C141.893 170.884 140.758 170.884 139.756 170.75C139.022 171.618 138.153 171.685 136.951 172.954C135.148 174.957 147.102 173.555 148.504 172.954C149.906 172.353 150.507 160.6 151.977 157.662C153.245 155.257 150.775 154.723 148.972 154.122Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M112.377 82.9365H82.1932C81.3251 82.9365 80.457 82.4023 80.1231 81.6009L67.9026 55.3569C67.3684 54.2217 67.8358 52.8193 69.0379 52.2851C70.1731 51.7509 71.5755 52.2183 72.1097 53.4203L83.6624 78.3288H112.377C113.646 78.3288 114.714 79.3972 114.714 80.666C114.714 81.9348 113.646 82.9365 112.377 82.9365Z",
    fill: "#536D9A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M118.721 73.8542C112.645 73.7874 106.568 70.1146 103.563 70.6488C100.558 71.1831 90.7412 77.9945 92.01 78.2616C93.2788 78.5287 101.025 74.522 101.292 74.4552C101.559 74.3885 103.229 77.2599 107.369 78.2616C111.509 79.3301 107.369 75.123 120.257 79.063C128.605 81.6006 118.721 73.8542 118.721 73.8542Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 1.05961
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M168.471 31.5159L169.339 38.728C169.339 38.728 161.459 39.1955 157.519 41.3992C153.579 43.6029 147.77 50.0136 147.77 50.0136L152.511 41.8666L153.179 36.6579L168.471 31.5159Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M119.908 73.9162C120.023 73.9233 120.157 73.9314 120.309 73.9406C120.873 73.9745 121.68 74.0216 122.652 74.0738C124.596 74.1783 127.202 74.3037 129.849 74.3873C132.494 74.4709 135.188 74.513 137.304 74.4499C138.36 74.4184 139.285 74.3604 139.992 74.2657C140.345 74.2185 140.657 74.1604 140.911 74.0871C141.14 74.0208 141.41 73.9187 141.588 73.7311C141.943 73.3576 142.611 72.4145 143.45 71.1261C144.3 69.8205 145.351 68.1192 146.481 66.194C148.74 62.3453 151.321 57.5864 153.235 53.2894L153.235 53.2881C155.146 48.9646 156.738 45.5793 158.562 43.3983C159.467 42.317 160.409 41.5567 161.45 41.1237C162.485 40.6933 163.653 40.5712 165.038 40.8224C167.671 41.3522 170.966 45.0733 170.111 52.8309C169.904 54.7123 168.885 57.4936 167.418 60.6664C165.96 63.8221 164.085 67.3099 162.211 70.584C160.337 73.8569 158.467 76.9097 157.02 79.1939C156.296 80.3359 155.679 81.2847 155.221 81.9717C154.992 82.3155 154.803 82.5922 154.661 82.7942C154.59 82.8953 154.533 82.9759 154.488 83.036C154.466 83.066 154.448 83.0895 154.434 83.107C154.419 83.1259 154.413 83.1328 154.413 83.1324L154.412 83.1339C154.413 83.1321 154.399 83.1478 154.352 83.176C154.306 83.2031 154.242 83.235 154.156 83.2702C153.982 83.3408 153.746 83.4136 153.445 83.4861C152.846 83.631 152.041 83.7639 151.08 83.884C149.161 84.1238 146.671 84.3067 144.071 84.4401C141.517 84.5711 137.449 84.2097 133.833 83.7014C132.029 83.4479 130.351 83.1597 129.044 82.8821C128.39 82.7431 127.835 82.6081 127.407 82.4829C126.96 82.352 126.704 82.2467 126.606 82.1829C125.953 81.7582 125.279 81.2654 124.766 80.8765C124.51 80.6825 124.296 80.5154 124.145 80.3969C124.07 80.3377 124.011 80.2908 123.971 80.2587L123.925 80.2222L123.914 80.213L123.911 80.2108L123.911 80.2103L123.91 80.2102L123.765 80.0921L123.577 80.0991L123.577 80.0991L123.575 80.0992L123.569 80.0994L123.541 80.1003C123.516 80.1011 123.479 80.1021 123.431 80.1032C123.336 80.1054 123.199 80.1077 123.032 80.1082C122.697 80.1092 122.247 80.103 121.781 80.0747C121.312 80.0461 120.843 79.9959 120.463 79.913C120.272 79.8716 120.119 79.8249 120.004 79.7755C119.948 79.7511 119.907 79.7286 119.879 79.7098C119.852 79.6917 119.843 79.681 119.842 79.6811L119.841 79.6796C119.839 79.6739 119.834 79.663 119.827 79.6455C119.811 79.5994 119.793 79.5299 119.775 79.4327C119.74 79.2383 119.715 78.9769 119.702 78.6614C119.674 78.033 119.692 77.2452 119.73 76.4657C119.767 75.6888 119.823 74.9312 119.869 74.367C119.883 74.1975 119.897 74.0456 119.908 73.9162Z",
    fill: "white",
    stroke: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M147.836 4.27082C136.751 4.80505 138.487 21.4997 138.487 21.4997C138.487 21.4997 141.359 22.3678 147.369 21.3662C146.902 19.5631 147.102 15.0222 147.102 15.0222C147.102 15.0222 147.77 18.7618 148.705 20.9655C149.973 21.5665 151.443 21.0323 153.847 20.4313C155.115 25.7068 158.655 27.9772 161.125 28.7118C163.797 29.5799 166.668 30.5816 169.873 28.9789C173.079 27.3762 171.276 11.149 169.606 7.87686C167.069 2.93524 162.862 -1.40537 155.583 0.865102C151.91 2.06712 147.836 4.27082 147.836 4.27082Z",
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M13.9453 174.157H16.9504L28.5031 85.5417H21.9587L13.9453 174.157Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M114.982 174.157H112.043L100.424 85.5417H106.968L114.982 174.157Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 351",
    d: "M141.359 73.3688C146.256 68.2491 156.785 56.7409 159.723 51.6657",
    stroke: "white",
    strokeWidth: 0.591091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 77304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    opacity: 0.15,
    d: "M130.511 79.3348C131.321 79.1303 133.533 77.9224 133.382 77.3265C133.231 76.7306 130.775 76.9725 129.966 77.177C129.156 77.3816 126.758 78.3665 126.909 78.9624C127.059 79.5582 129.702 79.5394 130.511 79.3348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    opacity: 0.15,
    d: "M153.216 54.6269C154.026 54.4223 156.238 53.2144 156.087 52.6185C155.936 52.0227 153.48 52.2645 152.671 52.4691C151.861 52.6736 149.463 53.6585 149.614 54.2544C149.764 54.8503 152.407 54.8314 153.216 54.6269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    opacity: 0.15,
    d: "M157.89 64.6435C158.699 64.439 160.911 63.2311 160.761 62.6352C160.61 62.0393 158.154 62.2812 157.345 62.4857C156.535 62.6903 154.137 63.6752 154.287 64.2711C154.438 64.8669 157.08 64.8481 157.89 64.6435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    opacity: 0.15,
    d: "M165.237 57.2974C166.046 57.0929 168.258 55.8849 168.108 55.2891C167.957 54.6932 165.501 54.935 164.691 55.1396C163.882 55.3442 161.484 56.3291 161.634 56.9249C161.785 57.5208 164.427 57.502 165.237 57.2974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    opacity: 0.15,
    d: "M166.572 49.2848C167.381 49.0803 169.593 47.8724 169.443 47.2765C169.292 46.6806 166.836 46.9225 166.026 47.127C165.217 47.3316 162.819 48.3165 162.969 48.9124C163.12 49.5082 165.762 49.4894 166.572 49.2848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    opacity: 0.15,
    d: "M152.548 84.6778C153.358 84.4732 155.57 83.2653 155.419 82.6695C155.269 82.0736 152.812 82.3154 152.003 82.52C151.193 82.7245 148.795 83.7094 148.946 84.3053C149.096 84.9012 151.739 84.8823 152.548 84.6778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    opacity: 0.15,
    d: "M151.212 73.3254C152.022 73.1208 154.234 71.9129 154.083 71.317C153.933 70.7212 151.476 70.963 150.667 71.1676C149.857 71.3721 147.459 72.357 147.61 72.9529C147.76 73.5488 150.403 73.5299 151.212 73.3254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    opacity: 0.15,
    d: "M140.528 81.3379C141.337 81.1334 143.549 79.9255 143.399 79.3296C143.248 78.7337 140.792 78.9756 139.982 79.1801C139.173 79.3847 136.775 80.3696 136.925 80.9655C137.076 81.5613 139.718 81.5425 140.528 81.3379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    opacity: 0.15,
    d: "M165.905 79.3348C166.714 79.1303 168.926 77.9224 168.776 77.3265C168.625 76.7306 166.169 76.9725 165.359 77.177C164.55 77.3816 162.152 78.3665 162.302 78.9624C162.453 79.5582 165.095 79.5394 165.905 79.3348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.15,
    d: "M167.24 69.3182C168.049 69.1136 170.261 67.9057 170.111 67.3098C169.96 66.714 167.504 66.9558 166.694 67.1604C165.885 67.3649 163.486 68.3498 163.637 68.9457C163.788 69.5416 166.43 69.5227 167.24 69.3182Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskPic);
export default __webpack_public_path__ + "static/media/DeskPic.c68763564a4bf31af11394fcea57877d.svg";
export { ForwardRef as ReactComponent };